export const ROOT = '/v2/'
export const SECURE_CONSTANTS = '/v2/secure_constants'
export const CONSTANTS = '/v2/constants'
export const ACCOUNTS = '/v2/accounts'
export const TNG_SURVEYS = '/v2/surveys'
export const EXTERNAL_SURVEYS = 'v2/external_surveys_v2'
export const CHECK_EMAIL_UNVERIFIED = '/v2/check_email_unverified'

export const INTERCOM_USER_HASHES = '/v2/accounts/me/constants'

// Profile Rewards
export const PROFILE_REWARDS_QUESTIONS = '/v2/profile_rewards/questions'

// Account Unveil
export const ACCOUNT_FULL_UNVEIL = '/v2/accounts/full_unveil'
export const ACCOUNT_FULL_UNVEIL_ASSOCIATED_IDS = '/v2/accounts/full_unveil/associated_ids'
export const ACCOUNT_FULL_UNVEIL_BREACH_DATA = 'v2/accounts/full_unveil/breach_data'
export const ACCOUNT_FULL_UNVEIL_NOTIFICATION_SUMMARY = 'v2/accounts/full_unveil/notification_summary'

// Browsing Rewards Statistics
export const BROWSING_REWARDS_STATISTICS = '/v2/browsing_rewards/statistics/'

// Data Footprint
export const DATA_FOOTPRINT_DATA_BUYERS = '/v2/data_footprint/data_buyers/'
export const DATA_FOOTPRINT_DATA_SELLERS = '/v2/data_footprint/data_sellers/'
export const DATA_FOOTPRINT_DATA_BREACHES = '/v2/data_footprint/data_breaches/'
